export const OBSERVATION_EDITING_MODULE_NAME = "ObservationEditing";
